import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { PartialBreakBlock } from '../blocks/PartialBreakBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const PartialBreaksLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { partialBreaks } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {partialBreaks.map((item, index) => (
        <PartialBreakBlock key={index} partialBreakModel={item} index={index} />
      ))}
    </LayerWrapper>
  )
}

export default PartialBreaksLayer
